import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/**
 * Builds a multi-page PDF from the Impact+ report DOM without using html2pdf.js
 * "slice one tall canvas" mode (which mis-paginates and shifts borders/dividers).
 * Each logical page node is rasterized on its own, then placed on one A4 sheet.
 */
function getReportPageElements(root: HTMLElement): HTMLElement[] {
  const inner = root.querySelector('.report-content-inner');
  if (!inner) return [];
  return Array.from(inner.children).filter(
    (n): n is HTMLElement =>
      n instanceof HTMLElement &&
      (n.classList.contains('report-cover') ||
        n.classList.contains('report-page') ||
        n.classList.contains('report-page-generated')),
  );
}

export async function downloadImpactReportPdfFromDom(
  root: HTMLElement,
  filename: string,
): Promise<void> {
  const pages = getReportPageElements(root);
  if (pages.length === 0) {
    throw new Error('No report pages found for PDF export');
  }

  const pdf = new jsPDF({ unit: 'pt', format: 'a4', orientation: 'portrait' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < pages.length; i++) {
    const el = pages[i];
    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      logging: false,
      width: el.scrollWidth,
      height: el.scrollHeight,
      windowWidth: el.scrollWidth,
      windowHeight: el.scrollHeight,
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.92);
    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, pageHeight);
  }

  pdf.save(filename);
}
